import React from "react";
import PropTypes from "prop-types";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import { Box } from "@mui/material";

import { LINKS } from "@constants";
import eventsService, {
  EVENTS,
  PAGE_VIEW_FROM,
  urlsToTrack,
} from "services/events";

const LogoText = ({
  asLink = true,
  showMobileLogo = true,
  dark = false,
  place,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname;

  const { isAuthenticated } = useSelector((state) => state.auth);

  const handleLogoClick = () => {
    if (asLink) {
      eventsService.track(EVENTS.LOGO, { place: place || urlsToTrack[path] });
      navigate(LINKS.home, { state: { from: PAGE_VIEW_FROM.logo } });
    }
  };

  return (
    <Box
      sx={{
        fontFamily: "Buduj",
        fontWeight: 700,
        fontSize: "15px",
        color: dark ? "#747484" : "var(--on-surface-primary)",
        textDecoration: "none",
        cursor: asLink ? "pointer" : "initial",
        display: "inline-flex",
      }}
      onClick={handleLogoClick}
      aria-label="Respeecher"
      role={asLink ? "link" : undefined}
    >
      <Box
        sx={{
          display: {
            md: "inline-block",
            sm: isAuthenticated ? "none" : "inline-block",
            xs: isAuthenticated ? "none" : "inline-block",
          },
        }}
        aria-hidden
      >
        respeecher
      </Box>
      {showMobileLogo && isAuthenticated && (
        <Box
          sx={{
            display: { md: "none", sm: "inline-block", xs: "inline-block" },
          }}
        >
          rs
        </Box>
      )}
    </Box>
  );
};

LogoText.propTypes = {
  asLink: PropTypes.bool,
  showMobileLogo: PropTypes.bool,
  dark: PropTypes.bool,
  place: PropTypes.string,
};

export default LogoText;
